import { v4 as uuidv4 } from 'uuid';
import { isSelectionBettingDisabled } from '@/utils/betting';

export function getSelectionId(source: any): number | null {
  return source?.selection?.id ?? source?.id ?? null;
}

export function isSelectionBet(bet: any): boolean {
  return Boolean(bet?.isSelectionBet && bet?.selectionId);
}

export function formatSelectionBetLabel(marketName: string, selectionName: string): string {
  const market = marketName?.trim() ?? '';
  const selection = selectionName?.trim() ?? '';
  if (market && selection) return `${market} - ${selection}`;
  return market || selection;
}

export function buildSelectionBetslip({
  selection,
  marketName,
  marketType,
  market,
  race,
  gameType,
  amount,
}: {
  selection: { id: number; name: string; displayName?: string; price: number | string; fields?: any[]; bet_closed?: boolean };
  marketName: string;
  marketType: string;
  market?: any;
  race: any;
  gameType: string;
  amount: number;
}) {
  const field = selection.fields?.[0];
  const selectionName = selection.displayName || selection.name;

  return {
    id: uuidv4(),
    gameType,
    selectionId: selection.id,
    isSelectionBet: true,
    fieldId: field?.field_id ?? null,
    number: field?.number ?? null,
    marketType,
    marketName,
    selectionName,
    marketTypeName: marketName || marketType,
    horseName: formatSelectionBetLabel(marketName, selectionName),
    raceId: race.race_id,
    raceExternalId: race.race_external_id,
    raceName: race.race_name,
    raceTime: race.race_time,
    countryName: race.country_name,
    odds: selection.price,
    amount,
    betClosed: isSelectionBettingDisabled(selection, market, race),
    eachWayBet: false,
    eachWayFraction: race.each_way_fraction,
    eachWayPlaces: race.each_way_places,
    isEW: false,
    isIncrease: null,
    runners: race.runners,
  };
}

export function buildTransactionBet(
  bet: any,
  { isMultiStake, totalStakeMulti, wagerTax }: { isMultiStake: boolean; totalStakeMulti: number; wagerTax: number }
) {
  const baseAmount = isMultiStake
    ? totalStakeMulti
    : (wagerTax > 0 ? bet.totalPaidAmount : bet.amount);
  const amount = bet.eachWayBet ? baseAmount * 2 : baseAmount;

  if (isSelectionBet(bet)) {
    return {
      amount,
      selections: [{
        selection_id: bet.selectionId,
        odds: String(bet.odds),
      }],
    };
  }

  const selections = bet.listHorse?.length > 0
    ? bet.listHorse.map((horse: any) => ({
        field_id: horse.fieldId,
        race_id: bet.raceId,
        position: horse.position,
      }))
    : [{
        field_id: bet.fieldId,
        race_id: bet.raceId,
        odds: bet.odds,
        position: null,
        each_way_bet: bet.eachWayBet,
      }];

  const market = bet.isEW ? 'win_or_ew' : (bet.marketType === 'sp' ? 'win' : bet.marketType);

  return { amount, market, selections };
}
